import { Controller } from '@hotwired/stimulus'
import type { App } from 'vue'

import { createApp } from '@app/adapters/create-app'
import GroupsTab from '@app/application/user-management/components/groups/groups-tab.vue'

export default class extends Controller {
  private app?: App

  connect(): void {
    this.app?.unmount()
    this.app = createApp(GroupsTab)
    this.app.mount(this.element)
  }

  disconnect(): void {
    this.app?.unmount()
    this.app = undefined
  }
}
